



































































































































































import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/Global/Loading.vue';
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';

import MmicReportList from '@/components/Reports/MmicReportList.vue';

import PolicyDocuments, { PolicyDocumentMetadata, PolicyPacket } from '@/services/PolicyDocuments';
import Policy from '@/services/Policy';
import Alert from '@/components/Global/Alert.vue';
import TextField from '@/components/Form/TextField.vue';
import { Getter, State } from 'vuex-class';
import store from '@/store/index';

import * as Sentry from '@sentry/browser';
import Brand from '@/services/Brand';
// Services
import Auth from '@/services/Auth';
import Reports from '@/services/Reports';
@Component({
	name: 'ReportsAccessWarning',
	components: {
		Loading,
		Sidebar,
		Alert,
		TextField,
	},
	computed: {
		user: () => store.state.Auth.user,
	},
})
export default class ReportsAccessWarning extends Vue {
	@Getter('thirtyDayPolicies', { namespace: 'Policy' }) private policies: any;
	@State('user', { namespace: 'Auth' }) private user: any;
	@Getter('reportsRequested', { namespace: 'Registration' })
	private reportsRequested: boolean;

	private year: any = new Date();
	private Auth: any;
	private hasAccess: boolean;
	private Brand: any;
	private reason: string;
	private error: boolean = false;
	private success: boolean = false;
	private role: string;
	private loading: boolean;
	constructor() {
		super();
		this.reason = '';
		this.role = '';
		this.Brand = Brand;
		this.error = false;
		this.success = false;
		this.loading = false;
	}
	private async agree() {
		if (this.hasAccess) {
			if (this.$route.query.reportsType === 'credential') {
				this.$router.push({
					name: 'credential-reports',
				});
			} else {
				this.$router.push({
					name: 'loss-history',
				});
			}
			window.localStorage.setItem('reportsAccess', JSON.stringify(true));
		} else {
			this.loading = true;
			try {
				const allPolicies = [];
				let clientId = null;
				this.policies.map(policy => {
					clientId = null;
					if (policy.client_id && policy.client_id !== 'undefined') {
						clientId = policy.client_id;
					} else if (this.user.isAgent === 'true') {
						const getMainRisk = Object.keys(policy.risks).filter(
							risk => policy.risks[risk].main_risk === 'Y',
						);
						clientId = policy.risks[getMainRisk[0]].client_id;
					}
					allPolicies.push({
						policy_number: policy.policy_number,
						client_id: clientId,
					});
				});

				await Reports.requestAccess({
					policy_numbers: allPolicies,
					reasonForRequest: this.reason,
					role: this.role,
				});
				this.success = true;
				this.$store.dispatch('Registration/setupReportsRequested', true);
			} catch (e) {
				this.error = true;
			} finally {
				this.loading = false;
			}
		}
	}
	private doNotAgree() {
		window.localStorage.setItem('reportsAccess', JSON.stringify(false));
		this.$store.dispatch('Registration/setupReportsRequested', false);
		this.$router.push({
			name: 'home',
		});
	}
	get brand() {
		return Brand.getBrand();
	}
	private async created() {
		this.hasAccess = Auth.checkPermission('VIEW_REPORTS') ? true : false;
		if (this.hasAccess) {
			if (this.$route.query.reportsType === 'credential') {
				this.$router.push({
					name: 'credential-reports',
				});
			} else {
				this.$router.push({
					name: 'loss-history',
				});
			}
		}
	}
}
